import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Repairs from "./pages/RepairsList";
import RepairForm from "./pages/RepairForm";
import RepairDetail from "./pages/RepairDetail";
import POS from "./pages/POS";
import Clients from "./pages/Clients";
import Inventory from "./pages/Inventory";
import Branches from "./pages/Branches";
import Credits from "./pages/Credits";
import CashRegister from "./pages/CashRegister";
import SalesList from "./pages/SalesList";
import SaleDetail from "./pages/SaleDetail";
import ReturnDetail from "./pages/ReturnDetail";
import Settings from "./pages/Settings";
import UsersPage from "./pages/Users";
import TimeClock from "./pages/TimeClock";
import TimeClockPunch from "./pages/TimeClockPunch";
import SearchResults from "./pages/SearchResults";
import PurchaseOrders from "./pages/PurchaseOrders";
import PurchaseOrderDetail from "./pages/PurchaseOrderDetail";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="text-slate-400">Cargando...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="text-slate-400">Cargando...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="text-slate-400">Cargando...</div></div>;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/clock" element={<TimeClockPunch />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="repairs" element={<Repairs />} />
            <Route path="repairs/new" element={<RepairForm />} />
            <Route path="repairs/:id" element={<RepairDetail />} />
            <Route path="pos" element={<POS />} />
            <Route path="clients" element={<Clients />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="minimos" element={<Inventory />} />
            <Route path="branches" element={<Branches />} />
            <Route path="credits" element={<Credits />} />
            <Route path="sales" element={<SalesList />} />
            <Route path="sales/:id" element={<SaleDetail />} />
            <Route path="returns/:id" element={<ReturnDetail />} />
            <Route path="cash-register" element={<CashRegister />} />
            <Route path="search" element={<SearchResults />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="purchase-orders/:id" element={<PurchaseOrderDetail />} />
            <Route path="checador" element={<AdminRoute><TimeClock /></AdminRoute>} />
            <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
            <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
